/* eslint-disable react/prop-types */
import React from 'react';
import { handleLogout } from '@blaze-cms/core-auth-ui';
import { useApolloClient } from '@apollo/client';

const abacusBasePath = process.env.ABACUS_BASE_PATH || 'https://shop.boatinternational.com';

const UserNavigation = ({ className, subMenuClass }) => {
  const client = useApolloClient();

  const navigateToAbacus = (path, returnUrl = null, newTab = true) => {
    const url = new URL(path, abacusBasePath);
    if (returnUrl) {
      const { searchParams } = url;
      searchParams.set('returnUrl', window.location.href);
      url.search = searchParams.toString();
    }

    const urlString = url.toString();
    if (newTab) {
      window.open(urlString);
    } else {
      window.location.href = urlString;
    }
  };

  const subMenuClassLinkClass = `${subMenuClass}-link`;

  return (
    <ul className={className}>
      <li className={subMenuClass}>
        <a
          onClick={() => navigateToAbacus('/myaccount')}
          role="link"
          className={subMenuClassLinkClass}>
          Account
        </a>
      </li>
      <li className={subMenuClass}>
        <a
          onClick={() => navigateToAbacus('/mysubscriptions')}
          role="link"
          className={subMenuClassLinkClass}>
          Subscriptions
        </a>
      </li>
      <li className={subMenuClass}>
        <a
          onClick={async () => {
            await handleLogout(client);
            navigateToAbacus('/Shop/ADShopLogoutUser.ashx', true, false);
          }}
          role="link"
          className={subMenuClassLinkClass}>
          Logout
        </a>
      </li>
    </ul>
  );
};

export default UserNavigation;
